var BookingSlotHandler = /** @class */ (function () {
    function BookingSlotHandler(modelManager, dirtyForm, options) {
        this.modelManager = modelManager;
        this.dirtyForm = dirtyForm;
        this.options = options;
    }
    BookingSlotHandler.prototype.getState = function (state) {
        return state;
    };
    BookingSlotHandler.prototype.toJSON = function (sanitizedState) {
        return sanitizedState;
    };
    BookingSlotHandler.prototype.toRequestBody = function (sanitizedState, fieldPaths) {
        // sanitizedState.rootCartItems.forEach((cartItem) => {
        //     if (!cartItem.isSchedulingTimespan) return;
        //     (cartItem.booking as CartItemBookingInterface).from = dateObjectOrNull(cartItem.bookingSlot?.from);
        //     (cartItem.booking as CartItemBookingInterface).to = dateObjectOrNull(cartItem.bookingSlot?.to);
        // });
        return sanitizedState;
    };
    return BookingSlotHandler;
}());
export { BookingSlotHandler };
